module.exports = __webpack_public_path__ + "static/media/profile.94a71ac2.png";